import React from "react";

import { Redirect, Route } from "react-router-dom";
import { useToken } from "contexts/UserContext";
import { LOGIN } from "routers/routePaths";

export const ProtectedRoute = ({ children, ...props }) => {
  const authenticated = useToken();

  return (
    <Route
      {...props}
      render={({ location }) =>
        authenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
